import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { GoogleAuthService } from '@auth/services/google-auth/google-auth.service';

@Component({
	selector: 'app-google-signin',
	imports: [CommonModule],
	templateUrl: './google-signin.component.html',
	styleUrl: './google-signin.component.scss',
})
export class GoogleSigninComponent {
	googleAuthService = inject(GoogleAuthService);
	isLoading = false;

	signUpWithGoogle(): void {
		this.isLoading = true;
		this.googleAuthService.signInWithGoogle().then(() => {
			this.isLoading = false;
		});
	}
}
